import { useRouter } from 'next/router';
import { Select, SelectItem } from '@nextui-org/react';
import { sortables } from '@/lib/constants';


const Sorting = () => {
  const router = useRouter();
  function handleChange(value: any) {
    // const { orderBy, sortedBy } = values;
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          orderBy: value,
        },
      },
      undefined,
      { scroll: false }
    );
  }
  return (
    <Select
      items={sortables}
      selectedKeys={[
        sortables.find((sortable) => sortable.value === router.query.orderBy)
          ?.value ?? sortables[0].value,
      ]}
      onChange={(e) => handleChange(e.target.value)}
      label="Sort by"
      size="sm"
      radius="full"
      className="h-[40px]! max-w-[180px] flex-shrink-0 hidden lg:block"
      classNames={{
        mainWrapper: 'h-[40px]!',
        base: 'h-[40px]!',
        trigger: 'h-[40px]! border-none',
        label: 'text-xs',
        value: 'text-white',
      }}
      variant="underlined"
    >
      {(sortable) => (
        <SelectItem key={sortable.value}>{sortable.label}</SelectItem>
      )}
    </Select>
  );
};

export default Sorting;
